// extracted by mini-css-extract-plugin
module.exports = {"svg-elem":"styles_svg-elem__wWQBM","active":"styles_active__Al82T"};